module.exports = __webpack_public_path__ + "static/img/sile.06339f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/northern/sile.png
// module id = xPis
// module chunks = 0